module.exports = ".head-row th a {\n  color: #2196f3 !important; }\n\n.footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.page-jumper-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: rgba(0, 0, 0, 0.54);\n  font-size: 12px;\n  padding-right: 8px; }\n\n.page-jumper-input {\n  width: 72px;\n  margin: 0 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/component/tablelist/tablelist.component.scss
// module id = ./src/app/common/component/tablelist/tablelist.component.scss
// module chunks = common